import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import StyledBgContainer from '../../components/StyledBgContainer/StyledBgContainer'
import dummyImage from '../../assets/Profile Full img.svg'
import Path from '../../router/localRoutes'
import './Profile.css'

const Profile = () => {
  const [searchParams] = useSearchParams()
  const image = searchParams.get('image') || dummyImage

  return (
    <StyledBgContainer>
      <div className="reg-consumer-main-container">
        <div className="reg-consumer-header">
          <Link to={Path.RegisteredConsumerDetails}>
            <img src="/icon/Arrow left.svg" alt="back" />
          </Link>
        </div>

        <div className="full-profile-img">
          <img src={image} alt="full profile" />
        </div>
      </div>
    </StyledBgContainer>
  )
}

export default Profile
